import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './root-reducer';

export type AppDispatch = typeof store.dispatch;

export const createAppStore = (initialState?: any) => {
	return configureStore({
		reducer: rootReducer,
		preloadedState: initialState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false,
			}),
		devTools: process.env.NODE_ENV !== 'production',
	});
};

export type RootState = ReturnType<typeof store.getState>;
export const store = createAppStore();
